<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>자료실</li>
        <li>약관 및 판례</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>약관 및 판례</h2>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <h3 class="conTit">약관 자료 다운로드</h3>
        <div class="tabStyle2">
          <table>
            <caption>
              약관 자료 다운로드
            </caption>
            <colgroup>
              <col width="*" />
              <col width="140" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62" class="tal pdl60">제목</th>
                <th scope="col" class="tal pdl20">자료</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td height="74" class="tal pdl60">적하 신약관 A</td>
                <td class="tal">
                  <button
                    @click="down('y_newa.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 신약관 A PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">적하 신약관 B</td>
                <td class="tal">
                  <button
                    @click="down('y_newb.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 신약관 B PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">적하 신약관 C</td>
                <td class="tal">
                  <button
                    @click="down('y_newc.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 신약관 C PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">적하 구약관 All Risk</td>
                <td class="tal">
                  <button
                    @click="down('y_oldall.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 구약관 All Risk PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">적하 구약관 F.P.A</td>
                <td class="tal">
                  <button
                    @click="down('y_oldfpa.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 구약관 F.P.A PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">적하 구약관 W.A</td>
                <td class="tal">
                  <button
                    @click="down('y_oldwa.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 구약관 W.A PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">적하 특별 약관</td>
                <td class="tal">
                  <button
                    @click="down('special.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 특별 약관 PDF 다운</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="conTit">판례 자료 다운로드</h3>
        <div class="tabStyle2">
          <table>
            <caption>
              판례 자료 다운로드
            </caption>
            <colgroup>
              <col width="*" />
              <col width="140" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62" class="tal pdl60">제목</th>
                <th scope="col" class="tal pdl20">자료</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td height="74" class="tal pdl60">분손 및 손해방지비</td>
                <td class="tal">
                  <button
                    @click="down('p_bns.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">분손 및 손해방지비 PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">보험금 1</td>
                <td class="tal">
                  <button
                    @click="down('p_insu01.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">보험금 1 PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">보험금 2</td>
                <td class="tal">
                  <button
                    @click="down('p_insu02.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">보험금 2 PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">구상금 1</td>
                <td class="tal">
                  <button
                    @click="down('p_om01.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">구상금 1 PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">구상금 2</td>
                <td class="tal">
                  <button
                    @click="down('p_om02.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">구상금 2 PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">구상금 3</td>
                <td class="tal">
                  <button
                    @click="down('p_om03.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">구상금 3 PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">보험기간</td>
                <td class="tal">
                  <button
                    @click="down('p_duration.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">보험기간 PDF 다운</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import encDownload from "@/common/encDownload";
const axios = inject("axios");

async function down(file) {
  const encFilePath = await encDownload.encryptData(
    "/attach/sea/ozd/pdf/cargo/",
    true
  );
  const encFileName = await encDownload.encryptData(file, true);

  return axios.download(
    "/downloadEnc.do?addFilePath=" + encFilePath + "&addFileNm=" + encFileName
  );

  // return axios.download("/download.do?addFilePath=/attach/sea/ozd/pdf/cargo/&addFileNm=" + file);
}
</script>
